import { useEffect } from 'react';
import { allSettled } from 'effector';
import {
  createFilterToolbarScope,
  FilterToolbarGate,
  setConfig,
  setFilters,
} from '../../model/main';
import { ErrorMessage } from '../../molecules/error';
import { FilterConfig, Filters } from '../../types';
import { FilterMenu } from '../menu';

export type Props = {
  // Пример src/features/tickets/organisms/table/sortFilterToolbar/index.tsx

  config: FilterConfig; // Конфиг с id, он используется как ключ в store
  filters: Filters; // json с фильтрами заданный в родительском разделе (обычно лежит в model/filters)
  isFilterDefault: boolean; // Вычисление - заданы фильтры или дефолтные
  resetFilters: (props?: any) => any; // Функция сброса фильтров
  setFiltersOutside: (filters: any) => void; // Функция установки фильтров для родительского раздела, сохраненных в store
  normalizeFilters?: (filters: Filters) => Filters; // Приведение текущих и сохраненных фильтров к одному формату перед сравнением
};

export const FilterToolbarBody = ({
  config,
  filters,
  isFilterDefault,
  resetFilters,
  setFiltersOutside,
  normalizeFilters,
}: Props) => {
  const scope = createFilterToolbarScope(config.id);

  const filtersString = JSON.stringify(filters);

  const initConfig = async () => {
    await allSettled(setConfig, {
      scope,
      params: config,
    });
  };

  useEffect(() => {
    const setFiltersFromOutside = async () => {
      await allSettled(setFilters, {
        scope,
        params: filters,
      });
    };

    setFiltersFromOutside();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersString]);

  useEffect(() => {
    initConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersString]);

  return (
    <>
      <FilterToolbarGate />

      <ErrorMessage />

      <FilterMenu
        isFilterDefault={isFilterDefault}
        resetFilters={resetFilters}
        setFiltersOutside={setFiltersOutside}
        normalizeFilters={normalizeFilters}
      />
    </>
  );
};
